// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","701":"homeM"}[chunkId] + "." + {"177":"6c51a803","701":"1dc71f3a"}[chunkId] + ".css";
};